import React, { memo, useRef, ReactNode } from "react"
import { Modal } from 'inter-site-components'
interface IOpenVideo {
  linkIframe: string;
  children: ReactNode;
}

type ModalProps = {
  close: () => void;
  open: () => void;
}

const OpenVideoComponent: React.FC<IOpenVideo> = ({ linkIframe, children }: IOpenVideo): React.ReactElement => {
  const modalRef = useRef<ModalProps>(null)
  return (
    <>
      <div
        className='col-12 col-md-6 col-lg-4 offset-xl-1 text-center mb-5 mb-md-0 order-md-last'
        onClick={() => modalRef.current && modalRef.current.open() }
      >
        {children}
      </div>
      <Modal ref={modalRef}>
        <div className='modal'>
          <div className='backdrop' onClick={() => modalRef.current && modalRef.current.close()} />
          <div className='content'>
            <div className='close-button' onClick={() => modalRef.current && modalRef.current.close()}>Fechar</div>
            <iframe width='100%' height='100%' src={linkIframe} frameBorder='0' 
            className='optanon-category-C0003' allow='autoplay; encrypted-media' allowFullScreen />
          </div>
        </div>
      </Modal>
    </>
  )
}

OpenVideoComponent.defaultProps = {
  linkIframe: '',
  children: <></>,
}

export default memo<IOpenVideo>(OpenVideoComponent)
